export const SET_STATUS = 'SET_STATUS'
export const SET_ISWEIXIN = 'SET_ISWEIXIN'
export const SET_USER = 'SET_USER'
export const SET_FILTERS = 'SET_FILTERS'
export const PUSH_FILTERS = 'PUSH_FILTERS'
export const SPLICE_FILTERS = 'SPLICE_FILTERS'
export const SET_NEED_LOGIN = 'SET_NEED_LOGIN'
export const SET_DURATION = 'SET_DURATION'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js